enum SignUpFormFields {
    NAME = 'NAME',
    MOBILE = 'MOBILE',
    EMAIL = 'EMAIL',
    PASSWORD = 'PASSWORD',
}
export default SignUpFormFields;
